import { fetchGetSupplyOrderDetailItem } from 'features/SupplyOrder/redux/outboundSODetail'
import { useParams } from 'react-router-dom'
import { shallowEqual, useAppDispatch, useAppSelector } from 'store'

const useTable = () => {
  const { id } = useParams<{ id: string }>()
  const dispatch = useAppDispatch()
  const { query, item } = useAppSelector((state) => state.outboundSODetail.products, shallowEqual)

  const handleChangePage = (page: number) => {
    dispatch(
      fetchGetSupplyOrderDetailItem({
        supplyOrderId: Number(id),
        params: {
          pageIndex: page - 1,
        },
      }),
    )
  }

  const handleChangeRowsPerPage = (rowsPerPage: number) => {
    dispatch(
      fetchGetSupplyOrderDetailItem({
        supplyOrderId: Number(id),
        params: {
          pageIndex: 0,
          pageSize: rowsPerPage,
        },
      }),
    )
  }

  return {
    query,
    item,
    handleChangePage,
    handleChangeRowsPerPage,
  }
}

export default useTable
